import { createAction, createPayloadAction } from '../../../core/helpers'

import {
  ADD_CHALLENGE,
  FETCH_CHALLENGES,
  RENAME_CHALLENGE,
  RESET_CHALLENGE_TREE,
  SET_DATA_FOR_RENAMING_CHALLENGE,
} from '../action-types'

export const cleanupFetchChallenges = createAction(FETCH_CHALLENGES.CLEANUP)
export const addChallenge = createPayloadAction(ADD_CHALLENGE)
export const renameChallenge = createPayloadAction(RENAME_CHALLENGE)
export const resetChallengeTree = createAction(RESET_CHALLENGE_TREE)

export const setDataForRenamingChallenge = createPayloadAction(
  SET_DATA_FOR_RENAMING_CHALLENGE,
)
